import type { MailRibbonGroup } from 'owa-mail-ribbon-store-shared-types';
import type { RibbonControlId, RibbonGroupId } from 'owa-ribbon-ids';
import { LabelPreferenceId } from 'owa-mail-ribbon-store-shared-types';
import { action } from 'satcheljs';

export default action(
    'saveMailRibbonConfiguration',
    (
        mailRibbonLayout: MailRibbonGroup[],
        controlsInOverflow: RibbonControlId[],
        removedDefaultGroups: RibbonGroupId[],
        staticGroupIdOrdering: RibbonGroupId[],
        showLabelsPreference: LabelPreferenceId
    ) => ({
        mailRibbonLayout,
        controlsInOverflow,
        removedDefaultGroups,
        staticGroupIdOrdering,
        showLabelsPreference,
    })
);
